import { render, staticRenderFns } from "./SearchAndSortPreferences.vue?vue&type=template&id=ec230200&"
import script from "./SearchAndSortPreferences.vue?vue&type=script&lang=js&"
export * from "./SearchAndSortPreferences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports